export const languages = ["en", "ru"]

export const defaultLocale = "ru"
